import React, { useState } from "react";
import CellFormatting from "./CellFormatting";
import {
  setLevel2Properties,
  updateLevel2Properties,
} from "../../../WorkbookSlice";
import { useDispatch } from "react-redux";
import { MdAutoAwesome } from "react-icons/md";
import SelectBox from "./FilterConfigCompComponents/SelectBox";

export default function ConditionalFormattingModal({
  data,
  ControllerProps,
  currentSheet,
  handleModal,
  closeModal,
  conditionalFormattedData,
  modalItemIndex,
}) {
  const {
    rename,
    measure: measureObject,
    rulesArray: receivedRulesArray,
    formattingModalWas,
  } = conditionalFormattedData?.[modalItemIndex] || {};

  // console.log(conditionalFormattedData?.[modalItemIndex]);

  let selectedValueString = "";

  if (rename !== undefined && measureObject !== undefined) {
    selectedValueString = `${measureObject.value}_${rename}`;
  }

  const { reduxKey } = ControllerProps;
  // console.log(reduxKey);
  
  const transformedData = data.map((item) => ({
    label: `${item.measure.value}(${item.rename})`,
    value: `${item.measure.value}_${item.rename}`,
  }));

  const [selectedValue, setSelectedValue] = useState(
    measureObject && rename
      ? `${measureObject.value}_${rename}`
      : transformedData[0].value
  );
  // console.log(selectedValue);

  const [applyAble, setApplyAble] = useState(true);
  const dispatch = useDispatch();
  const [rulesArray, setRulesArray] = useState(
    receivedRulesArray || [
      {
        measure: "",
        value1: "",
        conditions: "LessThan",
        style: {
          backgroundColor: "WHITE",
          color: "BLACK",
        },
        type: "new",
      },
    ]
  );
  // console.log(rulesArray);
  // console.log(rulesArray.length);

  const handleValueChange = (e) => {
    const selected = data.find(
      (item) => `${item.measure.value}_${item.rename}` === e.target.value
    );
    if (selected) {
      setSelectedValue(`${selected.measure.value}_${selected.rename}`);
    }
  };

  const saveConditionalFormatting = () => {
    const selected = data.find(
      (item) => `${item.measure.value}_${item.rename}` === selectedValue
    );

    if (selected) {
      const { rename, columnName, measure, nanoId } = selected;

      // Prepare the base value object
      const baseValue = {
        columnName,
        rename,
        isColorScaleAuto: false,
        measure,
        rulesArray,
        formattingModalWas: "Custom",
        columnNanoId: nanoId,
      };
      // console.log(baseValue);

      if (modalItemIndex === -1) {
        dispatch(
          setLevel2Properties({
            reduxKey,
            Sheetid: currentSheet.Sheetid,
            parentKey: "customization",
            value: baseValue, // Send baseValue with or without colorScale
            itemInArray: true,
          })
        );
      } else {
        const newUpdatedItem = {
          ...baseValue, // Reuse the same logic for updated item
        };
        dispatch(
          updateLevel2Properties({
            reduxKey,
            Sheetid: currentSheet.Sheetid,
            parentKey: "customization",
            value: newUpdatedItem,
            itemInArray: true,
            index: modalItemIndex,
          })
        );
      }
      closeModal();
    }
  };

  const handleAddRule = () => {
    setRulesArray([
      ...rulesArray,
      {
        measure: null,
        value1: null,
        conditions: "",
        style: {
          backgroundColor: "WHITE",
          color: "BLACK",
        },
        type: "new",
      },
    ]);
  };

  return (
    <main className="h-full w-full text-sm p-4 gap-4 flex flex-col items-center justify-center">
      {data.length === 1 ? (
        <div className="flex flex-col md:flex-row items-center justify-left w-full">
          <label className="w-16">Field : </label>
          {data.map((item, index) => (
            <button
              className="p-1 m-1 w-full text-left"
              key={index}
              value={`${item.measure.value}_${item.rename}`}
            >
              {`${item.measure.value} (${item.rename})`}
            </button>
          ))}
        </div>
      ) : (
        <div className="flex items-center justify-left w-full">
          <label className="w-16">Field : </label>
          <SelectBox
            value={selectedValue}
            onChange={handleValueChange}
            optionsArray={transformedData}
          />
        </div>
      )}

      <section
        className={`w-full border overflow-y-auto flex flex-col gap-2 items-start h-48`}
      >
        {rulesArray.length ? (
          rulesArray.map((rule, index) => {
            return (
              <CellFormatting
                isEditActive={false}
                rulesArray={rulesArray}
                rule={rule}
                setRulesArray={setRulesArray}
                index={index}
                conditionalFormattedData={conditionalFormattedData}
                selectedValue={selectedValue}
              />
            );
          })
        ) : (
          <CellFormatting
            isEditActive={true}
            rulesArray={rulesArray}
            rule={rulesArray[0]}
            setRulesArray={setRulesArray}
            index={0}
            conditionalFormattedData={conditionalFormattedData}
            selectedValue={selectedValue}
          />
        )}
      </section>

      <footer className="flex w-full text-sm items-center justify-between">
        <button
          className="w-20 flex items-center justify-center gap-2"
          onClick={() => handleModal("Auto")}
        >
          <MdAutoAwesome />
          Auto
        </button>
        <div className="flex flex-col md:flex-row items-center justify-between gap-2 w-full md:w-auto">
          <button onClick={handleAddRule} className="w-20 border py-1 px-3">
            Add
          </button>
          <button
            onClick={() => {
              formattingModalWas === "Custom"
                ? handleModal(null)
                : handleModal("Auto");
            }}
            className="w-20 border py-1 px-3"
          >
            Close
          </button>
          <button
            onClick={saveConditionalFormatting}
            disabled={!applyAble}
            className={`w-20 border text-white py-1 px-3 ${
              applyAble ? "bg-blue-950" : "bg-gray-500"
            }`}
          >
            Apply
          </button>
        </div>
      </footer>
    </main>
  );
}
